import styled from 'styled-components';

const Letter = styled.div`
  color: #fff;
  border-radius: 50%;
  text-align: center;
  background-color: #000;
  width: 30px;
  height: 30px;
  line-height: 34px;
  font-size: 15px;
  margin: 0 auto;
`;

export default Letter;
